<template>
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="d-flex flex-row">
          <div>
            <h3 class="card-title">
              <i class="ti-check-box"></i> {{ $t("Checklist") }}
            </h3>
          </div>
          <div class="ml-auto">
            <a class="reset-text" @click="clearItems()">
              {{ $t("Reset selection") }}
            </a>
          </div>
        </div>
        <div class="table-responsive">
          <tbody>
            <tr v-for="(item, i) in items" v-bind:key="item.id" class="checklist-item">
              <td class="checklist-item-title">
                {{ item.value }}
              </td>
              <td>
                <label :for="`itemChecked-${i}`">{{ $t("Yes") }}</label>
              </td>
              <td>
                <input type="radio" id="checkedTrue" :name="`itemChecked-${i}`" 
                  value="true" v-model="item.done" @change="itemChanged">
                <input type="radio" id="checkedTrue" :name="`itemChecked-${i}`" 
                  value="null" v-model="item.done" @change="itemChanged" style="display: none;">
              </td>
              <td>
                <label :for="`itemChecked-${i}`">{{ $t("No") }}</label>
              </td>
              <td>
                <input type="radio" id="checkedFalse" :name="`itemChecked-${i}`" 
                  value="false" v-model="item.done" @change="itemChanged"> 
              </td>
            </tr>
          </tbody>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import apiHelper from '../mixins/APIHelper';

export default {
  name: "checklist-widget",
  props: {
    'checklist_items': {
      default: [],
    },
    'enabled': {
      default: true,
    },
  },
  data: function() {
    return {
      meeting: this.$attrs.meeting_uid,
      widget_id: this.$attrs.widget_uid,
      items: [],
    }
  },
  mounted: function() {
    console.log(this.checklist_items);
    this.items = this.checklist_items;
  },
  methods: {
    itemChanged: function(){
      let vm = this;
      let data = {}
      Object.keys(vm.items).forEach((key) => {
        data[key] = vm.items[key].done;
        // Boolean conversion
        if (data[key] === "true" || data[key] === "false") {
          data[key] = (data[key] === "true");
        }
      });
      apiHelper.putResource(`/api/meeting/${vm.meeting}/checklist/${vm.widget_id}`, { checklist: data});
      const parentItems = JSON.parse(JSON.stringify(vm.$parent.dynamic_components));
      const checkListIndex = parentItems.findIndex((item) => {
        if (item.props) {
          return item.props.widget_uid === vm.widget_id;
        }
      });
      const itemIndex = vm.$parent.meeting_state;
      const normItem = vm.$parent.meeting_items[itemIndex].MeetingNormItem._Widgets[checkListIndex];
      Object.keys(normItem.Content).forEach(key => {
        normItem.Content[key].done = data[key];
      });
      console.log(normItem.Content);
    }, clearItems: function() {

      const checklistItems = JSON.parse(JSON.stringify(this.items));
      for (const item in checklistItems) {
        checklistItems[item].done = null;
      }
      this.items = checklistItems;
      this.itemChanged();
    },
  }
}
</script>
<style scoped>
  td {
    padding: 1rem;
  }
  td.checklist-item-title {
    padding-bottom: 0.5rem;
    padding-left: 1rem;
    width: 100%;
  }
  .checklist-item td{
    border-top: 1px solid #e9ecef;
  }
  .checklist-item input[type=radio] {
    position: relative !important;
    left: 0px;
  }
  div.col-12:not(.preview-disable) .checklist-item input[type=radio] {
    pointer-events: auto !important;
    opacity: 1;
  }
</style>


// WEBPACK FOOTER //
// src/components/CheckListWidget.vue